import { useSnapshot } from 'valtio'
import React, { type ReactElement, useEffect } from 'react'
import { Dialog } from '@headlessui/react'
import cn from 'classnames'
import { proxyNewUser, resetProxyNewUser } from '../../../../../shared/proxies/newUserProxy'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import { closeAddModal } from '../utils'
import { SubmitButton } from '../../../../../shared/components/ui/buttons/SubmitButton'
import { StandardInput } from '../../../../../shared/components/ui/forms/StandardInput'
import { handleBlur, handleChange, handleFormSubmit, handleEmailBlur } from './utils'
import { FormFieldNamesEnum } from './formFieldNamesEnum'

export interface IFormInput {
  [FormFieldNamesEnum.FirstName]: string
  [FormFieldNamesEnum.LastName]: string
  [FormFieldNamesEnum.Email]: string
  [FormFieldNamesEnum.IsAdmin]: boolean
}

export function NewUserFormModalHookForm (): ReactElement {
  const { displayUserAddModal, allowSubmit, formErrors, formValues, showEmailError, showFirstNameError, showLastNameError } = useSnapshot(proxyNewUser)
  const { siteTheme: { checkboxColors } } = useSnapshot(proxyGlobalAuth)
  useEffect(() => { resetProxyNewUser() }, [])

  return (

    <Dialog
      open={displayUserAddModal}
      onClose={() => { closeAddModal() }}
      className="fixed z-10 inset-0 overflow-y-auto"
    >

      <div className="flex items-center justify-center min-h-screen">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className="flex justify-cener mt-12">
          <PlaceholderBox loading={false} rows={20} additionalClasses="p-2">
            <form
              onSubmit={handleFormSubmit}
              className="bg-white rounded-lg py-6 px-8 border w-full flex flex-col "
            >
              <h3 className="font-medium text-xl mb-4 mx-auto">Add A New User</h3>
              <div className="w-full">
                <StandardInput
                  onBlur={handleEmailBlur(FormFieldNamesEnum.Email)}
                  onChange={handleChange(FormFieldNamesEnum.Email)}
                  placeholder="Email"
                  errorMessage={formErrors[FormFieldNamesEnum.Email] ?? ''}
                  showError={showEmailError}
                  value={formValues[FormFieldNamesEnum.Email] as string ?? ''}
                />

                <div className="flex mt-2 space-x-4">
                  <div className="w-full md:w-1/2">
                    <StandardInput
                      onChange={handleChange(FormFieldNamesEnum.FirstName)}
                      onBlur={handleBlur(FormFieldNamesEnum.FirstName)}
                      placeholder="First Name"
                      errorMessage={formErrors[FormFieldNamesEnum.FirstName] ?? ''}
                      showError={showFirstNameError}
                      value={formValues[FormFieldNamesEnum.FirstName] as string ?? ''}
                    />
                  </div>
                  <div className="w-full md:w-1/2">
                    <StandardInput
                      onChange={handleChange(FormFieldNamesEnum.LastName)}
                      onBlur={handleBlur(FormFieldNamesEnum.LastName)}
                      placeholder="Last Name"
                      errorMessage={formErrors[FormFieldNamesEnum.LastName] ?? ''}
                      showError={showLastNameError}
                      value={formValues[FormFieldNamesEnum.LastName] as string ?? ''}
                    />
                  </div>
                </div>

                <div className="w-full py-6">
                  <input
                    type="checkbox"
                    className={cn(checkboxColors.classes, 'ml-2 pl-8  pr-3  h-6 w-6')}
                    onBlur={handleBlur(FormFieldNamesEnum.IsAdmin)}
                    onChange={handleChange(FormFieldNamesEnum.IsAdmin)}
                    checked={!!formValues.isAdmin}
                  />
                  <label htmlFor="checkbox" className="ml-2">User is Admin</label>

                </div>

                <SubmitButton text="Submit" disabled={!allowSubmit} />

              </div>
            </form>
          </PlaceholderBox>
        </div>

      </div>

    </Dialog>
  )
}
